import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Sidenav/sgds-sidenav";
import { register } from "../../utils/ce-registry";

register("sgds-sidenav", Component);

export default createComponent({
  react: React,
  tagName: "sgds-sidenav",
  elementClass: Component,
  events: {}
});
